import UserRailyOfficerListResponse, {
  UserRailyOfficerListResponseItem,
} from "../../../../api/raily/user/raily-officer/list/user-raily-officer-list.response";
import UserRailyOfficerList, {
  UserRailyOfficerListItem,
} from "./user-raily-officer-list";

const createAlternativePhoneNumber = (
  responseDataItem: UserRailyOfficerListResponseItem,
): UserRailyOfficerListItem["alternativePhoneNumber"] => {
  if (
    !responseDataItem.mobileSecondary ||
    !responseDataItem.mobileSecondaryPrefix
  ) {
    return null;
  }

  return {
    dialingCode: responseDataItem.mobileSecondaryPrefix,
    number: responseDataItem.mobileSecondary,
  };
};

const createPhoneNumber = (
  responseDataItem: UserRailyOfficerListResponseItem,
): UserRailyOfficerListItem["phoneNumber"] => {
  return {
    dialingCode: responseDataItem.mobilePrimaryPrefix,
    number: responseDataItem.mobilePrimary,
  };
};

const createDataItem = (
  responseDataItem: UserRailyOfficerListResponseItem,
): UserRailyOfficerListItem => {
  return {
    email: responseDataItem.email,
    firstName: responseDataItem.firstName,
    lastName: responseDataItem.lastName,
    phoneNumber: createPhoneNumber(responseDataItem),
    alternativePhoneNumber: createAlternativePhoneNumber(responseDataItem),
    removalDate: responseDataItem.removedAt,
    username: responseDataItem.username,
    uuid: responseDataItem.id,
  };
};

const createData = (
  responseData: UserRailyOfficerListResponseItem[],
): UserRailyOfficerListItem[] => {
  return responseData.map(createDataItem);
};

const create = (
  response: UserRailyOfficerListResponse,
): UserRailyOfficerList => {
  return {
    data: createData(response.data.data),
    totalCount: response.data.totalCount,
  };
};

const userRailyOfficerListFactory = {
  create,
};

export default userRailyOfficerListFactory;
